import React, { useState } from 'react';

export default function AddressCardSelector({ options = [], selected: initialSelected = '' }) {
  const [selected, setSelected] = useState(initialSelected);

  if (!options.length) return null;

  function handleSelect(value) {
    // Il select resta la sorgente di verità: è lui a scatenare l'AJAX che
    // ricostruisce il pane.
    const el = document.querySelector('select.available-profiles');
    if (!el) return;

    setSelected(value);
    el.value = value;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  return (
    <div className="address-card-selector">
      {options.map(opt => (
        <button
          key={opt.value}
          type="button"
          className={[
            'address-card',
            selected === opt.value ? 'address-card--active' : '',
            opt.value === '_new' ? 'address-card--new' : '',
          ].filter(Boolean).join(' ')}
          onClick={() => handleSelect(opt.value)}
        >
          <div className="address-card__header">
            <span className="address-card__name">{opt.title}</span>
            <span className="address-card__radio" />
          </div>
          {opt.address && (
            <div className="address-card__body">
              <span className="address-card__line">{opt.address}</span>
            </div>
          )}
        </button>
      ))}
    </div>
  );
}
